import React, {useEffect, useState} from "react";
import {
  ColSpan2,
  ColTitle,
  CopyCode,
  RowSpan, SaveExcelButton,
  Script,
  Site,
  SubmitButton,
} from "../../assets/GlobalStyles";
import ReactDataGrid from '@inovua/reactdatagrid-enterprise';
import '@inovua/reactdatagrid-enterprise/base.css';
import '../../assets/default-light.scss'
import {useAtom, useSetAtom} from "jotai";
import {modalController} from "../../store";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import SettingAdd from "../common/SettingModal";
import {
  BorderBox,
  PreviewSubmit,
  Small,
  TitColor,
  TotalCount
} from "./styles";
import {exportCSV} from "../reports/ExportCSV";


export default function Table(props) {
  const {columns, data, settings, groups, noDirectives, defaultLimit, location, fileName } = props
  const [, setActiveCell] = useState([0]);
  const [gridRef, setGridRef] = useState(null);
  const gridStyle = {minHeight: 550}
  const columnData = () => {
    columns.map(item => {
      Object.assign(item, settings.default)
      return null
    })
    settings.setColumns.map(item => {
      Object.assign(columns[item.target], item.value)
      Object.assign(columns[item.target], item.function)
      return null
    })
  }

  useEffect(() => {
    if (settings !== undefined) {
      columnData()
    } else {
      columns.map(item => {
        Object.assign(item, {textAlign: 'center'})
        return null
      })
    }
    setActiveCell([data.length])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emptyText = <p style={{
    fontSize: 16,
  }}>{props.emptyText !== undefined ? props.emptyText : '데이터가 없습니다.'}</p>

  useEffect(() => {
    if (gridRef) {
      gridRef.current.setColumnSizesToFit()
    }
  }, [gridRef])

  /** 국제화 **/
  const i18n = Object.assign({}, ReactDataGrid.defaultProps.i18n, {
    sortAsc: '오름차순',
    sortDesc: '내림차순',
    unsort:'정렬 해제',
    autoSizeToFit:'크기에 맞게 자동 조정',
    autoresizeThisColumn:'열 자동 조정',
    autoresizeAllColumns:'모든 열 자동 조정',
    columns: '항목 설정',
    pageText: '페이지',
    ofText: '/',
    perPageText: '페이지 당',
    showingText: '페이지',
  })

  const renderRowContextMenu = (menuProps, { rowProps }) => {
    menuProps.autoDismiss = true
  }

  const gridElement = (
    <ReactDataGrid
      licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
      i18n={i18n}
      handle={setGridRef}
      columns={columns}
      dataSource={data}
      headerHeight={48}
      showZebraRows={true}
      showCellBorders={'horizontal'}
      groups={groups !== null ? groups : false}
      enableColumnAutosize={true}
      showColumnMenuLockOptions={false}
      showColumnMenuGroupOptions={false}
      emptyText={emptyText}
      defaultLimit={defaultLimit}
      pagination={props.pagination}
      style={gridStyle}
      showHoverRows={false}
      activeCell={null}
      renderRowContextMenu={renderRowContextMenu}
      {...props}
    />
  )
  return (
    <>
      {props.downloadList &&
        <RowSpan style={{justifyContent: 'flex-end'}}>
          <SaveExcelButton onClick={()=>exportCSV(gridRef, fileName)}>엑셀 저장</SaveExcelButton>
        </RowSpan>
      }
      <RowSpan>
        <ColSpan2 style={{paddingLeft: 0}}>
          {props.totalCount &&
            <TotalCount><span/>총 <span>{props?.totalCount[0]}</span> 건의 {props?.totalCount[1]}</TotalCount>}
        </ColSpan2>
        {noDirectives === true ? null : <Small>* shift를 누른 상태에서 스크롤시 좌우 스크롤이 가능합니다.</Small>}
      </RowSpan>
      {gridElement}
    </>
  )
}

